<div class="{{showTaskComponent ? 'hidden' : 'full-height-container'}}">
  <mat-card class="full-height-container">
    <mat-card-content class="full-height-container content-panel">
      <div class="flex-row">
        <app-component-header (downloadClickEvent)="this.handleDownloadClickEvent('ms-excel-survey-invitees')" (refreshClickEvent)="this.refreshView()"
                              [hideColumnsButton]="true" [quilliupGuid]="QuilliupForm.SURVEY_TRACKER.guid" [redirectTo]="'quilliup'"
                              [startRefreshTimer]="this.refreshComplete" [subtitleSegments]="getUrlSegments()" [uploadUrlParam]="{mode: 'upload'}"
                              [uploadUrl]="['task', 'upload']"
                              class="full-width">
        </app-component-header>
      </div>
      <div class="flex-row table-container">
        <ag-kpi-sidebar [sidebar]="kpiSidebar" class="mg-r-s"></ag-kpi-sidebar>
        <ag-grid-angular (columnVisible)="onColumnVisible($event)"
                         (filterChanged)="onFilterChanged($event)"
                         (firstDataRendered)="onFirstDataRendered($event)"
                         (gridReady)="onGridReady($event)"
                         (selectionChanged)="onRowSelectionChanged($event)"
                         (viewportChanged)="onViewportChanged($event)"
                         [columnDefs]="tableColumns"
                         [gridOptions]="baseAgGridOptions"
                         [overlayNoRowsTemplate]="noRowsTemplate"
                         [rowData]="rowData"
                         [suppressPropertyNamesCheck]="true"
                         class="ag-theme-quartz ag-grid-flex full-height-container">
        </ag-grid-angular>
        <ng-template #footerActionButtonPanel>
          <button (click)="onBulkRequestSurveyFiles()" [disabled]="!isBulkOperationAllowed" class="white-font-color mg-r-m" color="accent" mat-raised-button>
            <i class="fa-sharp fa-light fa-files"></i>
            Request Survey Files in Bulk
          </button>
          <button [routerLink]="['task', 'add']" class="white-font-color mg-r-m" color="primary" mat-raised-button>
            <i class="fa-sharp fa-light fa-add"></i>
            Add Row
          </button>
        </ng-template>
      </div>
    </mat-card-content>
  </mat-card>
</div>
<div class="{{showTaskComponent ? 'full-height-container': 'hidden' }}">
  <app-ms-excel-survey-invitees-task (goBackEvent)="goBack()" *ngIf="showTaskComponent" [selectedFeatureMode]="selectedFeatureMode" [selectedRows]="this.selectedRows"/>
</div>
